export default __webpack_public_path__ + "static/media/signature_prison.656ddca3.png";